import type { ComponentProps } from "react";
import { Button as Base } from "./ButtonBase";
import "./controls.web.css";

/** The web button: the shared button with the desktop control classes. */
export function Button({ className, ...props }: ComponentProps<typeof Base>) {
  return (
    <Base
      {...props}
      className={`desktop-button desktop-button-${props.size ?? "default"} ${className ?? ""}`}
    />
  );
}
